import React from 'react'
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import Routers from '../../routers/Routers.js';
 const Layout =()=> {
  return (
    <>

      <div>
        <Routers/>
      </div>

    </>
  )
}
export default Layout;